import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext.js';
import type { FiltersContext } from '@openx/components-filters/lib/context/types';
import { FILTER_TYPES } from '@openx/components-filters/lib/FiltersBar/types';
import type { InventoryListsListFilters } from '@openx/types/inventoryList';
import { OPEN_AUDIENCE_ORG_ID } from '@openx/utils/services/config';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../components/AuthContext/context';

export const useFiltersConfig = (): FiltersContext<InventoryListsListFilters>['filtersConfig'] => {
  const { t } = useTranslation();
  const { useAccountOptionsFetch } = useAdministrationContext();
  const { session } = useAuth();
  const isOpenAudienceOrg = session?.exchange_session.account?.id === OPEN_AUDIENCE_ORG_ID;

  const {
    accounts: { loading, mapById },
  } = useAccountOptionsFetch(isOpenAudienceOrg !== true);

  const filtersConfig: FiltersContext<InventoryListsListFilters>['filtersConfig'] = [
    {
      key: 'account_uid',
      name: t('Organization'),
      type: FILTER_TYPES.AUTOCOMPLETE,
      options: mapById
        ? Object.values(mapById)
            .filter(({ id }) => id)
            .map(({ id, name }) => ({ id, name }))
            .sort((a, b) => a.name.localeCompare(b.name))
        : [],
      config: {
        isLoading: loading,
      },
    },
  ];

  return isOpenAudienceOrg ? filtersConfig : [];
};
